import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'

import { REGISTRAZIONE } from '../../utils/endpoint'
import Trans from '../../components/atomic/Trans'
import { api } from '../../utils'
import { schemaResetPassword } from '../../components/registrazione/utils'
import { useRouter } from 'next/router'

api.defaults.xsrfCookieName = 'csrftoken'
api.defaults.xsrfHeaderName = 'X-CSRFTOKEN'

const getFieldClass = (field, values, errors) => {
  return errors[field] ? 'error' : values[field] !== '' ? 'valid' : ''
}

const ResetPassword = () => {
  const [step, setStep] = useState(1)
  const [success, setSuccess] = useState(false)

  const router = useRouter()

  const recuperaPassword = async (values) => {
    api
      .post(REGISTRAZIONE + 'reset_password/', {
        ...values,
        user_uid: router.query.user_uid,
        hash_value: router.query.hash_value,
      })
      .then((response) => {
        setStep(2)
        setSuccess(response.data.success)
      })
      .catch((error) => console.log(error))
  }

  useEffect(() => {
    if (!('user_uid' in router.query)) {
      router.replace('/')
    }
  }, [router.query])

  return (
    <main className="registrazione-page registrazione-page--recupera">
      <header className="registrazione-page__header">
        <div className="w-container">
          {/* <Breadcrumbs breadcrumbs={pagina.breadcrumbs} /> */}
          <h1 className="registrazione-page__title">
            <span>
              <Trans chiave="Reset password" />
            </span>
          </h1>
          <div className="registrazione-page__description">
            {step === 1 ? (
              <Trans chiave="Inserisci la nuova password" key={step} />
            ) : success ? (
              <Trans
                chiave="La password è stata modificata. Puoi effettuare il login"
                key={success}
              />
            ) : (
              <Trans chiave="Si è verificato un errore" key={success} />
            )}
          </div>
        </div>
      </header>
      <section className="registrazione__form-section">
        <div className="container">
          <div className="registrazione-page__form-box">
            {step === 1 && (
              <Formik
                initialValues={{ password: '', confermaPassword: '' }}
                validationSchema={schemaResetPassword}
                onSubmit={(values, { resetForm }) => {
                  recuperaPassword(values).then(() => resetForm())
                }}
                enableReinitialize
              >
                {({ values, errors, dirty, isSubmitting, isValid, handleChange }) => (
                  <Form className="registrazione-page__form w-form">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="w-form__field-wrapper">
                          <input
                            className={getFieldClass('password', values, errors)}
                            id="password"
                            name="password"
                            type="password"
                            value={values.password}
                            onChange={handleChange}
                          />
                          <label htmlFor="password">
                            <Trans chiave="Password*" />
                          </label>
                          <span className="w-form__error">{errors.password}</span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="w-form__field-wrapper">
                          <input
                            type="password"
                            className={getFieldClass('confermaPassword', values, errors)}
                            id="confermaPassword"
                            name="confermaPassword"
                            value={values.confermaPassword}
                            onChange={handleChange}
                          />
                          <label htmlFor="confermaPassword">
                            <Trans chiave="Conferma password*" />
                          </label>
                          <span className="w-form__error">{errors.confermaPassword}</span>
                        </div>
                      </div>
                    </div>
                    <div className="registrazione-page__submit-box">
                      <input
                        type="submit"
                        value="Conferma"
                        disabled={!dirty || isSubmitting || !isValid}
                        className="registrazione-page__submit-button button button--primary"
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            )}
          </div>
        </div>
      </section>
    </main>
  )
}

export default ResetPassword
